import React from 'react';
import PropTypes from 'prop-types';

import useComponentDidMount from 'Hooks/useComponentDidMount';

const BalanceSheetContext = React.createContext(undefined);

// Actions
export const FETCH_ADD_ACCOUNT_COLLECTION_STARTED = 'fetch-new-item-collection-started';
export const FETCH_ADD_ACCOUNT_COLLECTION_FINISHED = 'fetch-new-item-collection-succeeded';
export const FETCH_ADD_ACCOUNT_COLLECTION_FAILED = 'fetch-new-item-collection-failed';

export const SET_TAB_NAME = 'set-tab-name';
export const SET_SELECTED_LINE_ITEM_RESOURCE = 'set-selected-line-item-resource';

const init = () => {
  return {
    isFetchingAddAccountCollection: false,
    fetchingAddAccountCollectionError: null,
    tabName: 'assets',
  };
};

// Reducer
const reducer = (state, action) => {
  switch (action.type) {
    case SET_TAB_NAME: {
      return {
        ...state,
        tabName: action.tabName,
      };
    }
    case SET_SELECTED_LINE_ITEM_RESOURCE: {
      return {
        ...state,
        lineItemResource: action.lineItemResource,
      };
    }
    default: {
      throw new Error(`Unhandled BalanceSheetContext action type: ${action.type}`);
    }
  }
};

const BalanceSheetProvider = ({
  children,
}) => {
  const [state, dispatch] = React.useReducer(reducer, null, init);


  const handleSetTabName = React.useCallback(async (tabName) => {
    dispatch({ type: SET_TAB_NAME, tabName });
  }, []);

  const handleSetSelectedLineItemResource = React.useCallback(async (lineItemResource) => {
    dispatch({ type: SET_SELECTED_LINE_ITEM_RESOURCE, lineItemResource });
  }, []);

  const memoizedValue = React.useMemo(() => {
    return {
      tabName: state.tabName,
      selectedLineItemResource: state.selectedLineItemResource,
      handleSetTabName,
      handleSetSelectedLineItemResource,
    };
  }, [
    state,
    handleSetTabName,
    handleSetSelectedLineItemResource,
  ]);

  useComponentDidMount(async () => {
  });

  return (
    <BalanceSheetContext.Provider value={memoizedValue}>
      {children}
    </BalanceSheetContext.Provider>
  );
};

// Use Survey State Context
const useBalanceSheetContext = () => {
  const context = React.useContext(BalanceSheetContext);
  if (context === undefined) {
    throw new Error('useBalanceSheetContext must be used within a BalanceSheetProvider');
  }
  return context;
};

BalanceSheetProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export {
  BalanceSheetProvider,
  useBalanceSheetContext,
};
